<template>
    <PageLoader v-if="loading"/>

    <PageTitle v-else-if="checkUserRole('manager')" :page-title="`${tender?.type?.code === 'CO' ? 'Запрос' : 'Тендер'} №${tender?.id}`">
        <template #back-action-link>
            <a href="/personal/" class="back-link">Вернуться назад</a>
        </template>

        <template #btns v-if="checkUserRole('administrator') || checkUserRole('manager')">
            <div class="page-title__btns">
                <a :href="downloadUrl" download class="btn btn--border">Выгрузить в Excel</a>
                <button v-if="!checkUserRole('administrator')" class="btn btn--color" @click="handleCopyTender">Скопировать {{tender?.type?.code === 'CO' ? 'запрос' : 'тендер'}}</button>                

                <template v-if="checkStatus('подведение итогов') && (checkUserRole('administrator') || checkUserRole('manager'))">
                    <span class="page-title__btns-divider"></span>
                    <button class="btn btn--color" @click="handleRebiddingTender">Запустить переторжку</button>                
                    <button class="btn btn--color" @click="handleCompleteTender">Завершить тендер</button>
                </template>
            </div>
        </template>
    </PageTitle> 

    <div class="page-content">
        <div class="wrapper">
            <div class="page-content__wrapper page-content__wrapper--tender">
                <div class="page-content__aside">
                    <TenderInfo v-if="tender" :tender="tender" @updateData="loadTenderInfo"/>
                </div>
                <div class="page-content__content">
                    <div class="page-content__inner">
                        <TenderInnerTable v-if="tender" :data="tender" :can-send-offer="canSendOffer" @updateTender="loadTenderInfo"/>

                        <template v-if="tender?.description">
                            <hr >
                            <DetailInfo
                                :titleBlock="'Детальная информация о закупке'"
                                :text="tender?.description"
                            />
                        </template>

                        <docs-list v-if="tender?.documents" :docs-items="tender.documents" dark></docs-list>
                        <hr>
                        <button
                            v-if="checkUserRole('manager') && canCancelTender"
                            class="btn btn--border btn--cancel"
                            @click="handleCancelTender">
                            Отменить {{ tender?.type?.code === 'CO' ? 'запрос' : 'тендер' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <transition-group name="modal">
        <CancelTenderPopup
                v-if="showCancelTenderPopup"
                :tender="tender"
                @update-tender="loadTenderInfo"
                @close="showCancelTenderPopup = false"
        />  
        <CopyTenderPopup
                v-if="showCopyTenderPopup"
                :tender="tender"
                @close="showCopyTenderPopup = false"
        />  
        <CompleteTenderPopup
                v-if="showCompleteTenderPopup"
                :tender-id="tender.id"
                @update-tender="loadTenderInfo"
                @close="showCompleteTenderPopup = false"
        />        
        <RebiddingTenderPopup
                v-if="showRebiddingTenderPopup"
                :tender-id="tender.id"
                @update-tender="loadTenderInfo"
                @close="showRebiddingTenderPopup = false"
        />
    </transition-group>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

import PageTitle from "@/components/blocks/PageTitle.vue";
import DetailInfo from "@/components/blocks/DetailInfo.vue";
import DocsList from "@/components/blocks/DocsList.vue";
import CancelTenderPopup from "@/components/sections/Tenders/TenderInner/CancelTenderPopup.vue";
import CompleteTenderPopup from "@/components/sections/Tenders/TenderInner/CompleteTenderPopup.vue";
import CopyTenderPopup from "@/components/sections/Tenders/TenderInner/CopyTenderPopup.vue";
import RebiddingTenderPopup from "@/components/sections/Tenders/TenderInner/RebiddingTenderPopup.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import {useToast} from "vue-toastification";
import TenderInfo from "@/components/sections/Tenders/TenderInner/TenderInfo.vue";
import TenderInnerTable from "@/components/sections/Tenders/TenderInner/TenderInnerTable.vue";

export default {
    name: "TenderInner",
    components: {
        TenderInnerTable,
        TenderInfo,
        PageLoader,
        PageTitle, DetailInfo, DocsList, CancelTenderPopup, RebiddingTenderPopup, CompleteTenderPopup, CopyTenderPopup
    },
    props: {},
    data() {
        return {
            toast: useToast(),
            loading: true,
            tender: null,
            showRebiddingTenderPopup: false,
            showCompleteTenderPopup: false,
            showCancelTenderPopup: false,
            showCopyTenderPopup: false,
            offers: [],
        }
    },

   async mounted() {
        const id = (new URL(document.location)).searchParams.get("ID");
        await this.loadTenderInfo(id);
        await this.requestCities('all');

        this.getOffers.forEach(offer => {
            //Если способ досткавки только 1, выбираем его
            if (this.tender?.deliveries?.length === 1) {
            const value = this.tender.deliveries[0].id
            this.updateOffersKey({id: offer.position, key: 'delivery', value});
            this.updateOffersKey({id: offer.position, key: 'useRate', value: this.tender.deliveries[0].useRate});
            }

            //Если место доставки только 1, выбираем его
            if (this.tender?.deliveryDestinations?.length === 1) {
            const value = this.tender.deliveryDestinations[0].id;
                this.updateOffersKey({id: offer.position, key: 'deliveryDestination', value});
            }
        })
        await this.requestNdsList()
        await this.requestCurrenciesList()
        await this.connectToWebsocket()
    },
    computed: {
        downloadUrl() {
            const baseUrl = window?.location?.origin;
            return `${baseUrl}/api/tenders/export/excel/${this.tender.id}/`
        },
        canSendOffer() {
            const name = this.tender?.status?.name?.toLowerCase();
            return name === 'активный'
        },
        canCancelTender() {
            const name = this.tender?.status?.name?.toLowerCase();
            return name !== 'завершён' && name !== 'отменён'
        },
        ...mapGetters({
            isLoading: 'isLoading',
            getOffers: 'tenders/getOffers',
            checkUserRole: 'user/checkUserRole',
			getNewOfferTender: 'ws/getNewOfferTender',
            getNewStatusTender: 'ws/getNewStatusTender',
            getNewAuctionEnd: 'ws/getNewAuctionEnd',
        })
    },
    methods: {
        checkStatus(status) {
            return this.tender?.status?.name?.toLowerCase() === status;
        },
        async loadTenderInfo(id = this.tender.id) {
            const res = await this.requestTenderDetail(id);
            if (res.success) {
                this.tender = res.data;
            } else {
                if(window.location.hostname !== 'nahodka.localhost') {
                    // window.location.href="/personal/"
                }
            }
            this.loading = false;
        },
        handleCancelTender() {
            this.showCancelTenderPopup = true
        },

        handleRebiddingTender() {
            this.showRebiddingTenderPopup = true
        },
        handleCompleteTender() {
            this.showCompleteTenderPopup = true
        },
        handleCopyTender() {
            this.showCopyTenderPopup = true
        },
        
        ...mapActions({
            requestTenderDetail: 'tenders/requestTenderDetail',
            requestMakeTenderOffer: 'tenders/requestMakeTenderOffer',
            requestCities: 'delivery/requestCities',
            requestExportTenderToExcel: 'tenders/requestExportTenderToExcel',
            requestNdsList: 'tenders/requestNdsList',
            requestCurrenciesList: 'tenders/requestCurrenciesList',
            updateOffersKey: 'tenders/updateOffersKey',
			connectToWebsocket: 'ws/connectToWebsocket'
        })
    },
	watch: {
		getNewOfferTender(newValue) {
			const index = this.tender.positions.findIndex(item => item.id === newValue.positions[0].positionId)
			if (index !== -1) {
				if (newValue.id === this.tender.id) {
                    this.loadTenderInfo()
					this.toast.info(`Лучшая цена на ${this.tender.positions[index].product.name} изменилась`)
				}
			}
		},
		getNewStatusTender(newValue) {
			if (newValue.id === this.tender.id) {
                this.loadTenderInfo()
				this.toast.info('Статус изменился, информация обновлена')
			}

		},
	}
}
</script>


